export default function Stakeholders() {
  const stakeholders = [
    {
      name: 'إمارة المنطقة',
      relation: 'مؤثر',
      strategy: 'تقارير رسمية',
      frequency: 'دوري',
      icon: 'ri-government-line',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    },
    {
      name: 'الجمعيات',
      relation: 'مهتم',
      strategy: 'اجتماعات ومنصات',
      frequency: 'شهري',
      icon: 'ri-community-line',
      color: 'from-[#D4AF37] to-[#B8941F]'
    },
    {
      name: 'الرعاة والمانحون',
      relation: 'مؤثر/مهتم',
      strategy: 'عروض وتقارير',
      frequency: 'حسب الاتفاق',
      icon: 'ri-hand-heart-line',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 bg-[#D4AF37]/10 px-6 py-3 rounded-full">
              <i className="ri-links-line text-2xl text-[#D4AF37]"></i>
              <span className="text-sm font-bold text-[#D4AF37]">إدارة أصحاب المصلحة</span>
            </div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">
            شركاؤنا في النجاح
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            نبني علاقات استراتيجية مع جميع أصحاب المصلحة لضمان نجاح الملتقى وتحقيق أهدافه
          </p>
        </div>

        {/* Stakeholders Table */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden mb-16">
          {/* بطاقات الجوال */}
          <div className="md:hidden divide-y divide-gray-100">
            {stakeholders.map((stakeholder, index) => (
              <div key={index} className="p-4 flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 bg-gradient-to-br ${stakeholder.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                    <i className={`${stakeholder.icon} text-lg text-white`}></i>
                  </div>
                  <span className="text-base font-bold text-gray-800">{stakeholder.name}</span>
                </div>
                <div className="flex flex-wrap gap-2 text-sm">
                  <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full">{stakeholder.relation}</span>
                  <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full">{stakeholder.strategy}</span>
                  <span className="bg-[#D4AF37]/10 text-[#D4AF37] font-bold px-3 py-1 rounded-full">{stakeholder.frequency}</span>
                </div>
              </div>
            ))}
          </div>
          {/* جدول الديسكتوب */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-[#1B5E20] to-[#2E7D32]">
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">صاحب المصلحة</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">العلاقة</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white border-l border-white/20">استراتيجية التواصل</th>
                  <th className="px-6 py-5 text-right text-sm font-bold text-white">التكرار</th>
                </tr>
              </thead>
              <tbody>
                {stakeholders.map((stakeholder, index) => (
                  <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200">
                    <td className="px-6 py-5 border-l border-gray-100">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 bg-gradient-to-br ${stakeholder.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                          <i className={`${stakeholder.icon} text-lg text-white`}></i>
                        </div>
                        <span className="text-base font-bold text-gray-800">{stakeholder.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-5 border-l border-gray-100">
                      <span className="text-base text-gray-700">{stakeholder.relation}</span>
                    </td>
                    <td className="px-6 py-5 border-l border-gray-100">
                      <span className="text-base text-gray-700">{stakeholder.strategy}</span>
                    </td>
                    <td className="px-6 py-5">
                      <span className="inline-block px-4 py-2 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-sm font-bold">
                        {stakeholder.frequency}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-12 border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shake-hands-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">شراكات استراتيجية</h4>
              <p className="text-sm text-gray-600">بناء علاقات طويلة الأمد</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-message-3-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">تواصل فعّال</h4>
              <p className="text-sm text-gray-600">قنوات تواصل متعددة ومنظمة</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-bar-chart-box-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-2">تقارير دورية</h4>
              <p className="text-sm text-gray-600">شفافية كاملة في الأداء</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}